/**
 * Līguma skaitļi un biznesa konstantes. Vienīgais patiesības avots — §1 build promptā.
 * Šīs vērtības tiek izmantotas termiņu dzinī (S9), cenu dzinī (S5), reklamācijās (S8) u.c.
 */

/** Puses (§1). Reālie reģ./PVN/EORI numuri — HUMAN_HANDOFF (vietturi šeit). */
export const PARTIES = {
  platformEU: {
    legalName: 'Matisons Selection OÜ',
    brand: 'AmberNord',
    country: 'EE',
    market: 'eu',
    domain: 'b2b.ambernord.eu',
  },
  platformCH: {
    legalName: 'AmberNord (CH entity — TBD)',
    brand: 'AmberNord',
    country: 'CH',
    market: 'ch',
    domain: 'b2b.ambernord.ch',
  },
  supplier: {
    legalName: 'Unicorn Olivia UAB',
    brand: 'Zelt.bio',
    country: 'LT',
    regNo: '307030860',
    bioCert: 'LT-EKO-001.440-0004390.2025.001',
  },
} as const;

/** Termiņi darba dienās (d.d.) vai kalendārajās dienās/stundās (§1). */
export const DEADLINES = {
  /** Piegādātāja pasūtījuma apstiprinājums (darba dienas). */
  supplierConfirmationBusinessDays: 3,
  /** Rezerves piegādātāja trigeri. */
  fallbackNoConfirmationBusinessDays: 3,
  fallbackDelayCalendarDays: 7,
  fallbackConsecutiveNonconformingBatches: 2,
  /** Reklamācijas. */
  claimVisibleBusinessDays: 10,
  claimLatentDaysFromDiscovery: 30,
  claimLatentMaxMonths: 24,
  /** Datu aizsardzība. */
  dataBreachNotifyHours: 72,
  crisisDocsHours: 48,
  /** Auditi un paziņojumi. */
  auditNoticeBusinessDays: 10,
  auditMaxPerMonths: 12,
  subProcessorNoticeDaysAhead: 30,
  subProcessorObjectionDays: 14,
  /** DSR. */
  dsrForwardBusinessDays: 3,
  dsrAssistBusinessDays: 10,
  /** Reģistru atjaunināšana. */
  registryRefreshMonths: 6,
} as const;

/** Apdrošināšana (§1). */
export const INSURANCE = {
  baseCoverageEUR: 1_000_000,
  raisedCoverageEUR: 2_000_000,
  rollingTurnoverThresholdEUR: 50_000,
  raiseWithinDays: 60,
} as const;

/** Līguma termiņš. */
export const CONTRACT_TERM = {
  initialMonths: 24,
  autoRenewMonths: 12,
} as const;

/**
 * Apjoma atlaides — ritošie 12 mēn., uz produktu (§1, §8 S5).
 * minQty inclusive; maxQty inclusive (null = bez augšējās robežas).
 */
export const VOLUME_TIERS = [
  { tier: 1, minQty: 0, maxQty: 500, discount: 0.0 },
  { tier: 2, minQty: 501, maxQty: 1500, discount: 0.1 },
  { tier: 3, minQty: 1501, maxQty: 4000, discount: 0.15 },
  { tier: 4, minQty: 4001, maxQty: null, discount: 0.2 },
] as const;
export type VolumeTier = (typeof VOLUME_TIERS)[number];

/** Ātrās apmaksas atlaide (§1). */
export const EARLY_PAYMENT = {
  discount: 0.02,
  windowDays: 10,
} as const;

/** Cenu fiksācijas periods (§5 S5). */
export const PRICING = {
  fixationMonths: 12,
} as const;

/** Paraugu limiti (§13 S13). */
export const SAMPLES = {
  maxKgPerCategoryPerYear: 10,
  maxValueEURPerYear: 2000,
  discountAboveLimit: 0.3,
} as const;

/** Glabāšanas politikas (§5). */
export const RETENTION = {
  operationalMonths: 6,
  /** Operatīvie DOKUMENTI (CMR, pavadzīmes, skenējumi) — 10 g. (Erika lēmums 2026-09-04, pāri §5 6 mēn.). */
  operationalDocumentYears: 10,
  customerNameVatYears: 10,
  shipToAddressYears: 5,
  coaTechnicalYears: 5,
  retentionSamplePlusMonths: 6,
  r2AbortMultipartDays: 1,
} as const;

/** Triangulācijas juridiskā atzīme (§10). */
export const TRIANGULATION_NOTE =
  'VAT to be accounted for by the customer under Article 141 of Directive 2006/112/EC';

/** Lot Nr. formāts: YYYY-MM-DD-XXX (§6, §7). */
export const LOT_NO_REGEX = /^\d{4}-\d{2}-\d{2}-\d{3}$/;
